<div class="workspace no-back-btn">
  <div class="row">
    <div class="col-md-12">
      <div class="d-flex flex-column flex-auto">
        <div class="platform-settings-header">
          <div class="d-flex flex-auto flex-column">
            <div class="breadcumb-header">
              <span>{{'platform_settings.header' | translate}}</span>
            </div>
            <div class="breadcumb-subheader">
              <span>{{'platform_settings.sub_header' | translate}}</span>
            </div>
          </div>
        </div>
        <div class="seperate-setting-line"></div>
      </div>
    </div>
    <div class="col-md-12">
      <form #platformSettingForm="ngForm" class="platform-settings-form" (ngSubmit)="updatePlatformSettings()">
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex flex-column flex-auto">
              <div class="platform-setting-header">{{'platform_settings.billing_details_header' | translate}}</div>
              <div class="billing-detais-container">
                <achoo-text-field [(model)]="currentSettings.platformName"
                                  label="{{'platform_settings.platform_name' | translate}}"
                                  placeholder="{{'platform_settings.platform_name_placeholder' | translate}}"
                                  name="platformName"></achoo-text-field>
                <div class="d-flex flex-auto flex-column">
                  <div class="send-out-email-label">
                    {{'platform_settings.send_out_email' | translate}}
                  </div>
                  <div class="d-flex flex-auto flex-row">
                    <div class="email-name">
                      <achoo-text-field [(model)]="currentSettings.sendOutEmailName"
                                        placeholder="{{'platform_settings.send_out_email_name_placeholder' | translate}}"
                                        name="sendOutEmailName"></achoo-text-field>
                    </div>
                    <div class="email-domain">
                      <achoo-filter-box [options]="supportedDomains"
                                        name="sendOutEmailDomain"
                                        placeholder="{{'platform_settings.send_out_email_domain_placeholder' | translate}}"
                                        [(model)]="currentSettings.sendOutEmailDomain">
                      </achoo-filter-box>
                    </div>
                  </div>
                </div>
              </div>
              <div class="seperate-setting-line"></div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="d-flex flex-column flex-auto">
              <div class="platform-setting-header">{{'platform_settings.upload_logo' | translate}}</div>
              <div class="change-logo-container">
                <div class="d-flex flex-row flex-auto">
                  <div class="logo-dropzone" *ngIf="!logoImage">
                    <achoo-dropzone (uploadSuccessEvent)="onUploadLogoSuccess($event)"></achoo-dropzone>
                  </div>
                  <div class="logo-preview" *ngIf="logoImage">
                    <img [src]="logoImage">
                  </div>
                  <div class="action-button">
                    <div class="d-flex flex-column">
                      <span class="upload-message">{{'platform_settings.upload_logo_msg' | translate}}</span>
                      <div class="btn file upload-image" [ngClass]="{'disabled': isFreeUser}">
                        <span>{{'platform_settings.upload_btn' | translate}}</span>
                        <input *ngIf="!isFreeUser" type="file" name="file" (change)="onLogoImageSelected($event)">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="seperate-setting-line"></div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="d-flex flex-column flex-auto">
              <div class="platform-setting-header">{{'platform_settings.chart_colors_title' | translate}}</div>
              <div class="chart-colors-container">
                <div class="row">
                  <div class="col-md-6">
                    <div class="d-flex flex-auto flex-column">
                      <div class="color-picker-wrapper" *ngFor="let color of firstHalfPriorityColors; trackBy: trackColorChart; let i = index">
                        <achoo-color-field [(model)]="currentSettings.chartColors[i]"
                                           [color]="currentSettings.chartColors[i]"
                                           [priority]="i + 1"
                                           [placeholder]="'platform_settings.color_placeholder' | translate"
                                           [defaultColor]="defaultChartColors[i]"
                                           name="{{'chartColor' + i}}">
                        </achoo-color-field>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex flex-auto flex-column">
                      <div class="color-picker-wrapper" *ngFor="let color of secondHalfPriorityColors; trackBy: trackColorChart; let i = index">
                        <achoo-color-field [(model)]="currentSettings.chartColors[i + 5]"
                                           [priority]="i + 6"
                                           [color]="color"
                                           [placeholder]="'platform_settings.color_placeholder' | translate"
                                           [defaultColor]="defaultChartColors[i + 5]"
                                           name="{{'chartColor' + (i + 5)}}">
                        </achoo-color-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="seperate-setting-line"></div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="d-flex flex-column flex-auto">
              <div class="platform-setting-header">{{'platform_settings.app_setting_title' | translate}}</div>
              <div class="chart-colors-container">
                <div class="row">
                  <div class="col-md-6">
                    <div class="d-flex flex-column flex-auto">
                      <div class="app-settings-container">
                        <achoo-color-field  [(model)]="currentSettings.emailBgColor"
                                            [id]="'EmailBgColor'"
                                            [color]="currentSettings.emailBgColor"
                                            [label]="'platform_settings.email_bg_color_label' | translate"
                                            [placeholder]="'platform_settings.color_placeholder' | translate"
                                            [defaultColor]="defaultEmailBgColor"
                                            name="emailBgColor"></achoo-color-field>
                      </div>
                      <div class="app-settings-container" *ngFor="let color of firstHalfEmailButtonColors; trackBy: trackColorChart; let i = index;">
                        <achoo-color-field  [(model)]="currentSettings.emailButtonColors[i]"
                                            [id]="'EmailButtonColor' + (i + 1)"
                                            [color]="color"
                                            [label]="'platform_settings.email_button_color_label'| translate:{order: i + 1}"
                                            [placeholder]="'platform_settings.color_placeholder' | translate"
                                            [defaultColor]="defaultEmailButtonColors[i]"
                                            name="{{'emailButtonColor' + i}}"></achoo-color-field>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex flex-column flex-auto">
                      <div class="app-settings-container" *ngFor="let color of secondHalfEmailButtonColors;trackBy: trackColorChart; let i = index">
                        <achoo-color-field  [(model)]="currentSettings.emailButtonColors[i + 1]"
                                            [id]="'EmailButtonColor' + (i + 2)"
                                            [color]="color"
                                            [label]="'platform_settings.email_button_color_label'| translate:{order: i + 2}"
                                            [placeholder]="'platform_settings.color_placeholder' | translate"
                                            [defaultColor]="defaultEmailButtonColors[i + 1]"
                                            name="{{'emailButtonColor' + (i + 1)}}"></achoo-color-field>
                      </div>
                      <div class="app-settings-container">
                        <achoo-color-field  [(model)]="currentSettings.platformBgColor"
                                            [id]="'PlatformBgColor'"
                                            [color]="currentSettings.platformBgColor"
                                            [label]="'platform_settings.platform_bg_color_label' | translate"
                                            [placeholder]="'platform_settings.color_placeholder' | translate"
                                            [defaultColor]="defaultPlatformColor"
                                            name="platformBgColor"></achoo-color-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="seperate-setting-line"></div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="d-flex flex-column flex-auto">
              <div class="platform-setting-header">{{'platform_settings.bottombar_setting_title' | translate}}</div>
              <div class="chart-colors-container">
                <div class="row">
                  <div class="col-md-12">
                    <div class="app-settings-container">
                      <achoo-color-field  [(model)]="currentSettings.bottombarBgColor"
                                          [id]="'BottombarBgColor'"
                                          [color]="currentSettings.bottombarBgColor"
                                          [label]="'platform_settings.bottom_bar_bg_color_label' | translate"
                                          [placeholder]="'platform_settings.color_placeholder' | translate"
                                          [defaultColor]="defaultBottombarBgColor"
                                          name="bottombarBgColor"></achoo-color-field>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="d-flex flex-column flex-auto">
                          <div class="color-picker-wrapper" *ngFor="let color of firstHalfBottombarColors;trackBy: trackColorChart; let i = index">
                            <achoo-color-field [(model)]="currentSettings.bottombarButtonColors[i]"
                                               [color]="color"
                                               [label]="'platform_settings.bottom_bar_button_color_label'| translate:{order: i + 1}"
                                               [id]="'bottombarButtonColor' + (i + 1)"
                                               [placeholder]="'platform_settings.color_placeholder' | translate"
                                               [defaultColor]="defaultBottombarButtonColors[i]"
                                               name="{{'bottombarButtonColor' + i}}">
                            </achoo-color-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="d-flex flex-column flex-auto">
                          <div class="color-picker-wrapper" *ngFor="let color of secondHalfBottombarColors;trackBy: trackColorChart; let i = index">
                            <achoo-color-field [(model)]="currentSettings.bottombarButtonColors[i + 2]"
                                               [color]="color"
                                               [label]="'platform_settings.bottom_bar_button_color_label'| translate:{order: i + 3}"
                                               [id]="'bottombarButtonColor' + (i + 3)"
                                               [placeholder]="'platform_settings.color_placeholder' | translate"
                                               [defaultColor]="defaultBottombarButtonColors[i + 2]"
                                               name="{{'bottombarButtonColor' + (i + 2)}}">
                            </achoo-color-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="seperate-setting-line"></div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="bottombar">
  <div class="row">
    <div class="col-md-12 col-sm-12 buttons platform-setting-buttons">
      <button class="button save-button green pull-right" (click)="updatePlatformSettings()">{{'common.btn.save' | translate}}</button>
      <button class="button save-button blue pull-right" (click)="resetAll()">{{'common.btn.reset_all' | translate}}</button>
    </div>
  </div>
</div>

<achoo-popup #NotificationAfterSavingPlatformSettingSuccess
             [isNotification]="true"
             modelTitle="{{'notification.success' | translate}}">
  <span>{{'platform_settings.notification_save_successfully' | translate}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/admin/platform-settings/platform-settings.component.html